import React from 'react';
import { Feature, ColorFrom } from '@tencent/workbench';
import { GlowFeature } from '@framework/workbench/drawer/ui/effects/glow/glow-feature';
import { IChartGlowFeature } from './chart-glow-interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import ChartShapeProperty from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { INPUT_PROPS_CALLBACK_KEY } from '@src/framework/workbench/drawer/constants';
import { handleInputBlurInitAndReset } from '@src/slide/application/service/drawer-input-manager/drawer-handler';
import { NumberInputFrom, ColorOperations } from '@tencent/wb-ext-form';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';

const defaultGlowProps = {
    color: '#0E0E0E',
    opacity: 0,
    size: 0,
    tdColor: new TDColor({
        rgbaStr: '#0E0E0E',
    }),
};

export const GLOW_EMPTY = 'glow-empty';
const DEFAULT_WHITE_COLOR = '#000000';

@Feature()
export class ChartGlowFeature extends GlowFeature implements IChartGlowFeature {
    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_GLOW);
    }

    public getSelectModel(): any {
        const model = super.getSelectModel() as IChartModel;
        if (model?.type == UIModelType.CHART) {
            const chartSpace = model.getChartSpaceProperty() as ChartShapeProperty;
            if (!chartSpace) return model;
            return chartSpace;
        }
        return model;
    }

    public get glowInfo() {
        return (this.getSelectModel())?.getEffect?.()
            .getGlow() ?? { ...defaultGlowProps };
    }

    public updateGlowProps = (onlyChangeUI?: boolean, onPreview?: boolean) => {
        if (onlyChangeUI) return;
        const glow = { ...onPreview ? this.previewInfo : this.glowProps };
        const selectedModel = this.getSelectModel();
        selectedModel.updateEffect({ glow: { ...glow } });
    };

    @handleInputBlurInitAndReset(INPUT_PROPS_CALLBACK_KEY.CHART_GLOBAL_GLOW)
    public handleGlowChange(value, dragEnd?: boolean, from?: NumberInputFrom) {
        this.glowProps = { ...this.glowInfo, ...value };
        const onlyChangeUI = this.isInputOnlyChangeUIWithDrag(dragEnd);
        this.updateGlowProps(onlyChangeUI);
        this.handleChartGlobalGlowReport(value, from);
    }

    public handleGlowPresetStyleClick = (glow) => {
        this.getAppService().editableServiceLayer?.previewService?.updateElementPreviewState(false);
        this.glowProps = { ...defaultGlowProps, ...glow };
        this.updateGlowProps();
        this.tdwDrawerReport(ChartFormItemKey.CHART_GLOBAL_GLOW, { ver5: glow ? 2 : 1 });
    };

    private handleChartGlobalGlowReport = (value, from?: NumberInputFrom) => {
        let reportId;
        let ver6;
        if (value?.size) {
            reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE;
            ver6 = value.size;
        }
        if (value?.opacity) {
            reportId  = ChartFormItemKey.CHART_GLOBAL_SHADOW_OPICITY;
            ver6 = value.opacity;
        }
        this.tdwDrawerReportNumberInput(reportId, { ver6 }, from);
    };
}
